'use strict';

/* globals angular */

var SearchDirective = function () {

  var link = function link (scope, el) {
    var input = angular.element(el[0].children[0].children[0]);

    input.on('blur', function () {
      scope.input = '';
    });
  };

  function searchDirectiveController ($scope) {
    var vm = this;

    vm.placeholder = 'Search';
    vm.small = false;
    vm.isSearching = false;

    vm.changeIcon = function changeIcon () {
      vm.isSearching = !vm.isSearching;
    };

    vm.clearSearch = function clearSearch () {
      if ($scope.input) {
        $scope.input = '';
        $scope.onChange($scope.input);
      }
    };

    vm.onChange = function () {
      if ($scope.onChange) {
        $scope.onChange($scope.input);
      }
    };

    $scope.$watch('state', function (newV) {
      if (newV === 'detailed') {
        vm.placeholder = '';
        vm.small = true;
      } else {
        vm.placeholder = 'Search';
        vm.small = false;
      }
    });
  }
  searchDirectiveController.$inject = ['$scope'];

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Directive Definition Object
  /////////////////////////////////////////////////////////////////////////////////////////////////

  return {
    scope: {
      input: '=',
      onChange: '=',
      state: '=?'
    },
    templateUrl: 'settings/directives/search.tpl.html',
    controller: searchDirectiveController,
    controllerAs: 'vm',
    link: link
  };
};

module.exports = SearchDirective;



// WEBPACK FOOTER //
// ./src/app/settings/directives/SearchDirective.js